"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnswersForAttestationQuestion = void 0;
var _utils = require("../../../utils");
var _lodash = require("lodash");
// The attestation question includes a special answer for each medication we may prescribe.
// This filters the answers for just the ones that apply based on the patient's prescriptions.
var getAnswersForAttestationQuestion = function getAnswersForAttestationQuestion(question, prescriptions) {
  // Todo: should we filter for recent prescriptions or any other status info?
  var validPrescriptions = prescriptions.filter(_utils.isValidPrescription);
  if ((0, _lodash.isEmpty)(validPrescriptions)) {
    return null;
  }
  var hasPrescribedNaltrexone = validPrescriptions.some(function (_ref) {
    var genericDrugName = _ref.genericDrugName;
    return (0, _utils.isNaltrexone)(genericDrugName);
  });
  var hasPrescribedDisulfiram = validPrescriptions.some(function (_ref2) {
    var genericDrugName = _ref2.genericDrugName;
    return (0, _utils.isDisulfiram)(genericDrugName);
  });
  var answers = question.answers;
  if (!hasPrescribedNaltrexone) {
    answers = answers.filter(function (answer) {
      return answer.name !== _utils.ANSWER_CONFIRM_NALTREXONE_NAME;
    });
  }
  if (!hasPrescribedDisulfiram) {
    answers = answers.filter(function (answer) {
      return answer.name !== _utils.ANSWER_CONFIRM_DISULFIRAM_NAME;
    });
  }
  return answers;
};
exports.getAnswersForAttestationQuestion = getAnswersForAttestationQuestion;